module.exports = __webpack_public_path__ + "static/media/lds-logo_ro.1bfcd9ee.svg";